(function() {
    'use strict';

    function addColumnClass() {
        const sections = document.querySelectorAll('.icon-with-four-col');
        
        sections.forEach(function(section) {
            const iconGrid = section.querySelector('.icon-grid');
            
            if (iconGrid) {
                const iconCards = iconGrid.querySelectorAll('.icon-card');
                const itemCount = iconCards.length;
                
                // Only add class if items are less than 4
                if (itemCount < 4 && itemCount >= 2) {
                    const numberWords = {
                        2: 'two',
                        3: 'three'
                    };
                    const className = 'icon-with-' + numberWords[itemCount] + '-col';
                    section.classList.add(className);
                }
            }
        });
    }

    // Run on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', addColumnClass);
    } else {
        addColumnClass();
    }
})();
